import React from 'react';
import AppBar from './../AppBar/AppBar';
const Header = () => {
  return (
    <header>
      <AppBar />
    </header>
  );
};
export default Header;
